import { BirthdayGiftStore } from '@gamiphy/loyalty-station-desktop/store/birthdayGift';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { Trans } from '@gamiphy/react-i18n';
import { formatDate } from '@gamiphy/utils/date';
import {
  Grid,
  Typography,
} from '@mui/material';
import { addDays } from 'date-fns';
import { observer } from 'mobx-react';
import React from 'react';

const GoalAchieved: React.FC = () => (
  <Grid container>
    <Grid width="100%">
      <Typography fontSize="2.3rem" fontWeight={700} mt={1} mb={2} align="center">
        <Trans
          i18nKey="birthdayGift.goalAchieved"
          defaults="Goal achieved"
        />
      </Typography>
    </Grid>
    <Grid>
      <Typography fontSize={15} fontWeight={400} mb={2} align="center">
        <Trans
          i18nKey="birthdayGift.earned"
          defaults="Happy Birthday! <strong>You've earned a free cake!</strong> Collect it at your nearest Coop <strong>from {{startDate}} to {{endDate}}</strong>. 🎉"
          values={{
            startDate: UserStore.currentYearBirthDate && formatDate(UserStore.currentYearBirthDate),
            endDate: UserStore.currentYearBirthDate && BirthdayGiftStore.birthdayGift && formatDate(addDays(UserStore.currentYearBirthDate, BirthdayGiftStore.birthdayGift?.expiry)),
          }}
        />
      </Typography>
    </Grid>
  </Grid>
);

export default observer(GoalAchieved);
